import type { FC} from 'react';
import { useState } from 'react'

interface TipItemProps {
  icon: string
  title: string
  description: string
  learnMoreContent?: string
  index: number
}

/**
 * Individual tip component with expandable learn-more content
 */
export const TipItem: FC<TipItemProps> = ({
  icon,
  title,
  description,
  learnMoreContent,
  index
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div
      className="p-3 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
      data-testid={`tip-item-${index}`}
    >
      <div className="flex items-start gap-2">
        <span className="text-xl flex-shrink-0" aria-hidden="true">{icon}</span>
        <div className="flex-1 min-w-0">
          <h5 className="font-medium text-gray-900 text-sm">{title}</h5>
          <p className="text-xs text-gray-600 mt-1">{description}</p>
          {learnMoreContent && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-xs text-blue-600 hover:text-blue-700 mt-1 focus:outline-none focus:underline"
              aria-expanded={isExpanded}
              data-testid={`tip-learn-more-${index}`}
            >
              {isExpanded ? 'Show less ↑' : 'Learn more →'}
            </button>
          )}
        </div>
      </div>
      {isExpanded && learnMoreContent && (
        <div
          className="mt-2 pl-7 text-xs text-gray-600 border-l-2 border-blue-200 animate-fadeIn"
          data-testid={`tip-expanded-${index}`}
        >
          <p>{learnMoreContent}</p>
        </div>
      )}
    </div>
  )
}

export default TipItem
